import mapboxgl from 'mapbox-gl';
import React from 'react';
import {createRoot} from 'react-dom/client';

import '@fontsource/lato/100.css';
import '@fontsource/lato/300.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';

import {loadHelpScout} from 'app/integrations/helpscout';
import {loadHubspot} from 'app/integrations/hubspot';
import {initSentry} from 'app/tools/Sentry';
import {isPublicLensUrl} from 'app/utils/routeUtils';

import App from './view';

const MOUNT_ELEMENT_ID = 'root';

initSentry();

// Nobody viewing a share link has a support account for either widget to identify, and both
// append containers to <body> that end up in the report's printed output.
if (!isPublicLensUrl()) {
  loadHelpScout();
  loadHubspot();
}

// Prewarm was added in 1.10 and the types haven't caught up to it
(mapboxgl as any).prewarm();

const container = document.getElementById(MOUNT_ELEMENT_ID);
const root = createRoot(container!);
root.render(<App />);
